import React from "react";
import Marquee from "../review/Marquee";
import PetGroup from "../../../public/assets/pet-tag/pet-group.png";
import Image from "next/image";

import { DM_Serif_Display } from "next/font/google";

const dmSerifDisplay = DM_Serif_Display({
  subsets: ["latin"],
  weight: ["400"],
});

function QuoteSection() {
  return (
    <section className="h-auto lg:h-[616px] bg-[#150049] flex items-center relative pet-quote-bg">
      <Marquee direction="left" reverse={false} pauseOnHover={false}>
        <Image src={PetGroup} alt="bg" />
      </Marquee>

      <div className="w-[302px] h-[287px] md:h-[341px] md:w-[643px] bg-white absolute text-center top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%]  flex flex-col justify-center items-center space-y-[14px] lg:space-y-[24px] rounded-[0.813rem] lg:rounded-[1.5rem] shadow-pet-quotes-card-shadow">
        <div className="w-[36px] h-[36px] md:w-[56px] md:h-[56px] relative">
          <Image src="/assets/pet-tag/pet-logo.svg" fill alt="pet-logo" />
        </div>
        <p
          className={`text-[#050426] text-[22px] md:text-[32px] leading-[30.8px] md:leading-[44.8px] text-center w-[250px] md:w-[548px] ${dmSerifDisplay.className}`}
        >
          A pet’s safety is a measure of our love, care, and
          responsibility—because they trust us to keep them safe.
        </p>
        <p className="text-[#666] text-xs md:text-base font-medium">
          - Team AmarPet -
        </p>
      </div>
    </section>
  );
}

export default QuoteSection;
